import { withPermission } from '@/components/Permissions';
import { useNavigate } from 'react-router-dom';
import { HomeCard } from './homeCard';
import { Auth } from '@/@types';
import { TRACK_EVENTS } from '@/providers/eventAnalytics/trackEvents';
import { eventAnalytics } from '@/providers';

export function MedicationCard({ medications }: { medications: Array<{ medication: string }> }) {
  const navigate = useNavigate();
  const Card = withPermission(HomeCard, Auth.Permissions.UserPermissions.VIEW_MEDICATIONS);

  return (
    <Card
      category='Medications'
      list={medications?.map((m) => m.medication)}
      buttons={[
        {
          label: 'View all',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Medications',
              buttonClicked: 'View all',
            });
            return navigate('/medications');
          },
        },
      ]}
    />
  );
}
